export default __webpack_public_path__ + "static/media/whatsapp-notice-m-1.39289615.webp";